import { Minus, Plus, RefreshCw } from "lucide-react";
import { useTran } from "@/hooks";
import { NxmapMatchRow, STATUS_CONFIG } from "./NxmapMatchRow";

const STATUS_ICONS = { new: Plus, updated: RefreshCw, unchanged: Minus };

export function NxmapSyncPreview({ preview, disclosureCode }) {
  const { t } = useTran();
  const matches = preview?.matches ?? [];
  const summary = preview?.summary;

  return (
    <div className="space-y-3">
      <div className="rounded-md border border-border bg-muted/40 px-3 py-2 text-xs text-muted-foreground space-y-0.5">
        {preview.companyName && (
          <p>
            <span className="font-medium">{t("Company")}:</span>{" "}
            {preview.companyName}
          </p>
        )}
        <p>
          <span className="font-medium">{t("Year")}:</span> {preview.year}
        </p>
        <p>
          <span className="font-medium">{t("Framework")}:</span>{" "}
          {preview.framework}
        </p>
      </div>

      {matches.length === 0 ? (
        <div className="py-6 text-center text-sm text-muted-foreground">
          {t(
            "No matching data found for {{code}}. NXMap may not have data for {{year}}.",
            { code: disclosureCode, year: preview.year },
          )}
        </div>
      ) : (
        <>
          {summary && (
            <div className="flex items-center gap-3 text-xs">
              {summary.new > 0 && (
                <span className="text-green-600 dark:text-green-400 font-medium">
                  {summary.new} {t("new")}
                </span>
              )}
              {summary.updated > 0 && (
                <span className="text-yellow-600 dark:text-yellow-400 font-medium">
                  {summary.updated} {t("to update")}
                </span>
              )}
              {summary.unchanged > 0 && (
                <span className="text-muted-foreground">
                  {summary.unchanged} {t("unchanged")}
                </span>
              )}
            </div>
          )}

          <div className="max-h-64 overflow-y-auto rounded-md border border-border divide-y divide-border">
            {matches.map((match, i) => {
              const cfg = STATUS_CONFIG[match.syncStatus] || STATUS_CONFIG.new;
              return (
                <NxmapMatchRow
                  key={i}
                  match={match}
                  StatusIcon={
                    STATUS_ICONS[match.syncStatus] || STATUS_ICONS.new
                  }
                />
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
